import { render, staticRenderFns } from "./PredefinedField.vue?vue&type=template&id=22b4396e"
import script from "./PredefinedField.vue?vue&type=script&lang=js"
export * from "./PredefinedField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports